import React from 'react';

import { MixedImagePanel } from '@bingads-webui-campaign-react/ads-studio-app-components';
import { notificationApi } from '../../adapters/get-notification';

export const MixedImagePanelPage = props => (
  <MixedImagePanel {...props} notificationApi={notificationApi} />
);
